#import "../fragments/onboarding-checklist-item-fragment.graphql"

query GetOnboardingChecklist {
    onboardingChecklist {
        items {
            ...OnboardingChecklistItem
        }
        percentComplete
        isAvailable
        canRemove
    }
}
